import { css } from 'styled-components';
import { isDefaultTheme } from './theming.js';

var focusOutline = css(["outline:0.2rem solid var(--color-focus-outline);outline-offset:0.2rem;box-shadow:0 0 0 0.4rem var(--color-white);", ""], isDefaultTheme(css(["border-radius:0.4rem;"])));

export { focusOutline };
//# sourceMappingURL=mixins.js.map
